<template>
  <button :class="{working, shaking, highlighting}"
          :disabled="disabled"
          @click="onClick"
  >
    <span v-if="working"
          class="spinner"
    >
    </span>
    <slot v-else></slot>
  </button>
</template>

<script>
import delay from 'CORE/utils/delay'

export default {
    name: 'ActiveButton',
    components: {
    },
    props: {
        click: {
            type: Function,
            required: false,
            default: _ => null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: _ => false,
        },
        confirmText: {
            type: String,
            required: false,
            default: _ => null,
        },
        fncParam: {
            type: null,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            working: false,
            shaking: false,
            highlighting: false,
        }
    },
    watch: {
        disabled(newVal, oldVal) {
            console.info({ newVal, oldVal })
            // if (n === true) {
            this.highlighting = true
            // }
        },
    },
    methods: {
        async onClick(e) {
            if (this.confirmText !== null) {
                await this.$prompt(this.confirmText)
            }
            if (this.working) {
                this.shaking = true
                await delay(500)
                this.shaking = false
            } else {
                this.working = true
                try {
                    await this.click(this.fncParam === null ? e : this.fncParam)
                } catch (e) {
                    throw e
                } finally {
                    this.working = false
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.working {
    cursor: wait;
}

.highlighting {
    animation: blink 300ms cubic-bezier(1,0.5,0.58,1) 0s 2 alternate;
}

.spinner {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    border-left: 3px solid rgba(0,0,0,0.3);
    border-right: 3px solid rgba(0,0,0,0.3);
    border-top: 3px solid rgba(0,0,0,0.3);
    border-bottom: 3px solid rgba(0,0,0,0.9);
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,1);
    border-radius: 1rem;
    animation: rotate-center 3s ease-in-out infinite reverse both;
    // margin-left: 0.35rem;
    // position: absolute;
}

button.shaking:hover {
  animation: jello-horizontal 0.9s both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes blink {
    0% {
        filter: saturate(1);
    }
    50% {
        filter: saturate(3);
    }
    100% {
        filter: saturate(1);
    }
}

@keyframes rotate-center {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(1080deg);
  }
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

@keyframes jello-horizontal {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}

</style>
